// 从 localStorage 读取持久化的步骤状态
const getSavedStepState = () => {
    try {
        const saved = localStorage.getItem('flightStepState');
        if (saved) {
            return JSON.parse(saved);
        }
    } catch (e) {
        console.error('读取步骤状态失败:', e);
    }
    return { maxStep: 0, stepHistory: {} };
};

const savedState = getSavedStepState();

const state = {
    startPlace: '上海',
    endPlace: '北京',
    departureDate: new Date().toISOString().split('T')[0],
    maxStep: savedState.maxStep,
    stepHistory: savedState.stepHistory
};

// 保存步骤状态到 localStorage
const saveStepState = (state) => {
    try {
        localStorage.setItem('flightStepState', JSON.stringify({
            maxStep: state.maxStep,
            stepHistory: state.stepHistory
        }));
    } catch (e) {
        console.error('保存步骤状态失败:', e);
    }
};

const mutations = {
    setStartPlace(state, newPlace) {
        state.startPlace = newPlace;
    },
    setEndPlace(state, newPlace) {
        state.endPlace = newPlace;
    },
    setDepartureDate(state, newDate) {
        state.departureDate = newDate;
    },
    setMaxStep(state, step) {
        state.maxStep = step;
        saveStepState(state);
    },
    setStepHistory(state, { step, params }) {
        state.stepHistory[step] = params;
        saveStepState(state);
    },
    resetStepsFrom(state, step) {
        state.maxStep = step + 1;
        for (let i = step + 1; i < 5; i++) {
            delete state.stepHistory[i];
        }
        saveStepState(state);
    },
    resetAllSteps(state) {
        state.maxStep = 0;
        state.stepHistory = {};
        saveStepState(state);
    }
};

const actions = {
    updateStartPlace({ commit }, newPlace) {
        commit('setStartPlace', newPlace);
    },
    updateEndPlace({ commit }, newPlace) {
        commit('setEndPlace', newPlace);
    },
    updateDepartureDate({ commit }, newDate) {
        commit('setDepartureDate', newDate);
    },
    updateMaxStep({ commit }, step) {
        commit('setMaxStep', step);
    },
    updateStepHistory({ commit }, payload) {
        commit('setStepHistory', payload);
    },
    resetStepsFrom({ commit }, step) {
        commit('resetStepsFrom', step);
    }
};

const getters = {
    getStartPlace(state) {
        return state.startPlace;
    },
    getEndPlace(state) {
        return state.endPlace;
    },
    getDepartureDate(state) {
        return state.departureDate;
    },
    getMaxStep(state) {
        return state.maxStep;
    },
    getStepHistory(state) {
        return state.stepHistory;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
